import { LOGIN_NOISE_PATTERNS } from '@cli-constants/process-output.js'

export function showVercelLoginLine(line: string): boolean {
  return !LOGIN_NOISE_PATTERNS.some((pattern) => pattern.test(line))
}
